import { PLACEHOLDER_DAPP_ICON_SRC } from '../constants';

// If we don't have an icon OR the icon is already hte placeholder dapp icon
export const isPlaceholderDappIcon = (icon: string | null) => {
  return !icon || icon === PLACEHOLDER_DAPP_ICON_SRC;
};
